import { gql } from '@apollo/client';

export const SEND_CONTACT_TO_SLX = gql`
  mutation contactSlx($input: ContactSlxInput!) {
    contactSlx(input: $input)
  }
`;
